module.exports = __webpack_public_path__ + "img/组1070.97410b58.png";